// Thin Ajax cart wrapper around Shopify's /cart.js endpoints
window.ShopifyCart = (function () {
  const r = window.theme.routes;
  const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };

  async function get() {
    const res = await fetch(r.cart_get_url, { headers });
    return res.json();
  }
  async function add(id, quantity = 1, properties = {}) {
    const res = await fetch(r.cart_add_url + '.js', {
      method: 'POST', headers,
      body: JSON.stringify({ items: [{ id, quantity, properties }] }),
    });
    if (!res.ok) throw new Error('add failed');
    return res.json();
  }
  async function change(line, quantity) {
    const res = await fetch(r.cart_change_url + '.js', {
      method: 'POST', headers,
      body: JSON.stringify({ line, quantity }),
    });
    return res.json();
  }
  async function update(updates) {
    const res = await fetch(r.cart_update_url + '.js', {
      method: 'POST', headers,
      body: JSON.stringify({ updates }),
    });
    return res.json();
  }
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }
  return { get, add, change, update, formatMoney };
})();
